import { render, staticRenderFns } from "./amount-diff-tips-dialog.vue?vue&type=template&id=c25f2bc2&scoped=true&"
import script from "./amount-diff-tips-dialog.vue?vue&type=script&lang=ts&"
export * from "./amount-diff-tips-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./amount-diff-tips-dialog.vue?vue&type=style&index=0&id=c25f2bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25f2bc2",
  null
  
)

export default component.exports